type Props = {
  width?: React.CSSProperties["width"];
  height?: React.CSSProperties["height"];
  color?: React.CSSProperties["color"];
};

function Redirection(props: Props) {
  const { width = "16", height = "16", color = "#0060DD" } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0004 0.309C14.9627 0.217721 14.8988 0.139661 14.8167 0.0846679C14.7347 0.0296752 14.6382 0.000213667 14.5394 0H10.5394C10.4068 0 10.2796 0.0526784 10.1859 0.146447C10.0921 0.240215 10.0394 0.367392 10.0394 0.5C10.0394 0.632608 10.0921 0.759785 10.1859 0.853553C10.2796 0.947321 10.4068 1 10.5394 1H13.3294L6.17942 8.15C6.08834 8.2443 6.03794 8.3706 6.03908 8.5017C6.04022 8.6328 6.0928 8.75821 6.18551 8.85091C6.27821 8.94361 6.40362 8.9962 6.53472 8.99734C6.66582 8.99848 6.79212 8.94808 6.88642 8.857L14.0364 1.707V4.497C14.0364 4.62961 14.0891 4.75679 14.1829 4.85055C14.2766 4.94432 14.4038 4.997 14.5364 4.997C14.669 4.997 14.7962 4.94432 14.89 4.85055C14.9837 4.75679 15.0364 4.62961 15.0364 4.497V0.497C15.036 0.432468 15.0231 0.368627 14.9984 0.309H15.0004Z"
        fill={color}
      />
      <path
        d="M3.5 2C2.83696 2 2.20107 2.26339 1.73223 2.73223C1.26339 3.20107 1 3.83696 1 4.5V11.5C1 12.163 1.26339 12.7989 1.73223 13.2678C2.20107 13.7366 2.83696 14 3.5 14H10.5C11.163 14 11.7989 13.7366 12.2678 13.2678C12.7366 12.7989 13 12.163 13 11.5V6.5C13 6.36739 12.9473 6.24021 12.8536 6.14645C12.7598 6.05268 12.6326 6 12.5 6C12.3674 6 12.2402 6.05268 12.1464 6.14645C12.0527 6.24021 12 6.36739 12 6.5V11.5C12 11.8978 11.842 12.2794 11.5607 12.5607C11.2794 12.842 10.8978 13 10.5 13H3.5C3.10218 13 2.72064 12.842 2.43934 12.5607C2.15804 12.2794 2 11.8978 2 11.5V4.5C2 4.10218 2.15804 3.72064 2.43934 3.43934C2.72064 3.15804 3.10218 3 3.5 3H8.5C8.63261 3 8.75979 2.94732 8.85355 2.85355C8.94732 2.75979 9 2.63261 9 2.5C9 2.36739 8.94732 2.24021 8.85355 2.14645C8.75979 2.05268 8.63261 2 8.5 2H3.5Z"
        fill={color}
      />
    </svg>
  );
}

export default Redirection;
